import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async getUnits({ commit }) {
      try {
        const url = `/units`
        const response = await api.get(url)

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
